/**
 * created by yxy
 * 阵地维护
 */
import React from "react";
import BaseComponent from "../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import Schedule from './components/schedule'
import Popular from './components/popular'
import MediaStatus from './components/mediaStatus'
import AddModal from "../positionStatisticAnalysis/addModal/AddModal";
import { CUSTOM_CONFIG } from '../../../../config/customConfig';
export default class PositionOverview extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            currentTabs:''
        };
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }


    render() {
        return (
            <div style={{height: 'calc(100vh - 100px)',marginTop:15}}>
            <Scrollbars autoHide autoHeight autoHeightMax={'calc(100vh - 100px)'} style={{borderRadius: "5px"}}
                        className={'statistic'}>
                <MediaStatus></MediaStatus>
                <Schedule
                    callBack={(data) => {
                        this.setState({currentTabs: data}, () => {
                            this.hot.getTopList(this.state.currentTabs);
                            this.last.getList(this.state.currentTabs)
                        })
                    }}>
                </Schedule>
                <Popular
                    currentTabs ={this.state.currentTabs}
                    ref={ref => this.hot = ref}
                    type={'popular'}
                    title={CUSTOM_CONFIG?.POSITION_OVERVIEW?.SHOW_TOP_TEN_HOT_ARTICLE_TITLE ||' 热门文章Top5'}>
                </Popular>
                <Popular
                    currentTabs ={this.state.currentTabs}
                    ref={ref => this.last = ref}
                    type={'last'}
                    title={'最新文章'}>
                </Popular>
                <style>{`.statistic .ant-tabs-bar{border-bottom:none !important}
                        .statistic .ant-tabs-nav { height: 55px;line-height:35px}
                
                }`}</style>
            </Scrollbars>
            </div>


        );
    }
}